import { render, staticRenderFns } from "./customer_summary.vue?vue&type=template&id=bba9b650&scoped=true&"
import script from "./customer_summary.vue?vue&type=script&lang=js&"
export * from "./customer_summary.vue?vue&type=script&lang=js&"
import style0 from "./customer_summary.vue?vue&type=style&index=0&id=bba9b650&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba9b650",
  null
  
)

export default component.exports